import _ from "lodash"

const INDEX_SEGMENT = /\/\d+(?=\/|$)/g


const toTemplatePointer = (pointer) =>
    String(pointer ?? "").replace(INDEX_SEGMENT, "/[i]")

const segmentsOf = (pointer) =>
    String(pointer ?? "")
        .split("/")
        .filter(Boolean)

let defaultsByPointer = {}
let templatesByArrayPointer = {}

export const registerDefaults = (defaults) => {
    if (defaults) defaultsByPointer = {...defaultsByPointer, ...defaults}
}

export const registerDefaultTemplates = (templates) => {
    if (templates) {
        templatesByArrayPointer = {...templatesByArrayPointer, ...templates}
    }
}

export const registerDefaultsFromResponse = (response) => {
    registerDefaults(response?.defaults)
    registerDefaultTemplates(response?.defaultTemplates)
}

export const defaultFor = (pointer) => {
    if (!pointer) return undefined
    if (pointer in defaultsByPointer) return defaultsByPointer[pointer]
    const templatePointer = toTemplatePointer(pointer)
    const separator = templatePointer.indexOf("/[i]/")
    if (separator < 0) return undefined
    const arrayPointer = templatePointer.slice(0, separator)
    const fieldPointer = templatePointer.slice(separator + "/[i]".length)
    const template = templatesByArrayPointer[arrayPointer]
    if (!template || !(fieldPointer in template)) return undefined
    return template[fieldPointer]
}


export const buildDefaultEntry = (arrayPointer) => {
    const template = templatesByArrayPointer[toTemplatePointer(arrayPointer)]
    if (!template) return {}
    const entry = {}
    for (const [fieldPointer, defaultValue] of Object.entries(template)) {
        if (fieldPointer.includes("[")) continue
        _.set(entry, segmentsOf(fieldPointer), defaultValue)
    }
    return entry
}
